import { createContext, useState } from "react";

export const PermissionsContext = createContext();

export const PermissionsContextProvider = ({ children }) => {
  const [permissions, setPermissions] = useState(null);
  const [userPermissions, setUserPermissions] = useState(null);

  return (
    <PermissionsContext.Provider
      value={{ permissions, setPermissions, userPermissions, setUserPermissions }}
    >
      {children}
    </PermissionsContext.Provider>
  );
};
